import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Col, Badge,
} from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import DataTable from '../../../shared/components/DataTable';
import TextBox from '../../../shared/components/form/TextBox';
import DatePicker from '../../../shared/components/form/DatePicker';
import ModalForm from '../../../shared/components/form/Modal';
// import MallaEditarMateria from './MateriaMalla/MateriaMallaForm';

import validate from './validate';

class MallaForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleDeleteMateriaMalla: PropTypes.func.isRequired,
    submitting: PropTypes.bool,

    id: PropTypes.number,
    carreras: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    materias: PropTypes.arrayOf(PropTypes.shape({})),
    carrera: PropTypes.shape({}),
    usarPorDefecto: PropTypes.bool,
    activo: PropTypes.bool,

    history: PropTypes.shape({}).isRequired,
  }

  static defaultProps = {
    id: 0,
    submitting: false,
    materias: [],
    carrera: {},
    usarPorDefecto: false,
    activo: false,
  }

  constructor(props) {
    super(props);

    this.editMateriaMalla = this.editMateriaMalla.bind(this);
    this.deleteMateriaMalla = this.deleteMateriaMalla.bind(this);

    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      filters: { id: 20 },
      modal: true,
    };

    this.columns = [
      {
        key: 'semestreNroOrden',
        name: 'Semestre',
        search: false,
        width: '120px',
        className: 'text-center',
        format: row => (
          <h5>
            <Badge
              key={`mat_${row.id}`}
              color={row.semestreNroOrden % 2 === 0 ? 'secondary' : 'primary'}
            >
              {` ${row.semestreNroOrden}º`}
            </Badge>
          </h5>
        ),
      },
      {
        key: 'materia',
        name: 'Materia',
        search: false,
        format: row => `${row.codigoMateria} - ${row.materia}`,
      },
      {
        key: 'areaConocimiento',
        name: 'Area Conocimiento',
        className: 'text-center',
      },
      {
        key: 'horasLaboratorioSemestral',
        name: 'Horas Laboratorio Semestral',
        className: 'text-center',
      },
      {
        key: 'horasPracticaSemestral',
        name: 'Horas Practica Semestral',
        className: 'text-center',
      },
      {
        key: 'horasTeoriaSemestral',
        name: 'Horas Teoria Semestral',
        className: 'text-center',
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar materia" />,
        callback: (materiaMalla) => {
          this.editMateriaMalla(materiaMalla);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Borrar materia" />,
        callback: (materiaMalla) => {
          this.deleteMateriaMalla(materiaMalla);
        },
      },
    ];
  }

  agregarOquitarMaterias = (malla) => {
    if (malla) {
      const { id, history } = this.props;
      history.push(`/pages/mallas/edit/${id}/materias`);
    }
  };

  editMateriaMalla = (materiaMalla) => {
    if (materiaMalla) {
      const { id, history } = this.props;
      this.setState({ modal: true });

      history.push(`/pages/mallas/subjects/edit/${id}/${materiaMalla.id}`);
    }
  };

  deleteMateriaMalla = (materiaMalla) => {
    if (materiaMalla) {
      const { handleDeleteMateriaMalla } = this.props;
      handleDeleteMateriaMalla(materiaMalla);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateSubjectsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateSubjectsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  handleOkModal = () => this.toggle();

  handleCancelModal = () => this.toggle();

  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      id,
      carreras,
      materias,
      usarPorDefecto,
      activo,
    } = this.props;

    const {
      page,
      pageSize,
      totalItemsCount,
      filters,
      modal,
    } = this.state;

    const canAddMateriaMalla = false;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            {canAddMateriaMalla && (
              <ModalForm
                {...{ header: true, colored: false }}
                color="primary"
                title="Datos de la materia por malla"
                isOpen={modal}
                toggle={this.toggle}
                onOk={this.handleOkModal}
                onCancel={this.handleOkModal}
                okButtonText="Guardar"
              >
                {'<MallaEditarMateria />'}
              </ModalForm>
            )}
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={12} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos de la Malla</h5>
                </div>
              </Col>
              <Col md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Nombre</span>
                  <div className="form__form-group-field">
                    <Field
                      name="nombre"
                      component={TextBox}
                      placeholder="Nombre"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>

              <Col md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Carrera</span>
                  <div className="form__form-group-field">
                    <Field
                      name="carrera"
                      component={renderSelectField}
                      placeholder="Carrera"
                      autoComplete="false"
                      options={carreras}
                    />
                  </div>
                </div>
              </Col>


              <Col md={6} lx={8}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha Vigencia</span>
                  <div className="form__form-group-field">
                    <Field
                      name="fechaVigencia"
                      component={DatePicker}
                      placeholder="Fecha Vigencia"
                      autoComplete="false"
                    />
                  </div>
                </div>

              </Col>

              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label ">{' '}</span>
                  <div className="form__form-group-field">
                    <Field
                      name="usarPorDefecto"
                      component={renderCheckBoxField}
                      label="Usar por defecto?"
                      value={usarPorDefecto ? 'checked' : ''}
                      defaultChecked={usarPorDefecto}
                    />
                  </div>
                </div>
              </Col>

              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label ">{' '}</span>
                  <div className="form__form-group-field">
                    <Field
                      name="activo"
                      component={renderCheckBoxField}
                      label="Activo?"
                      value={activo ? 'checked' : ''}
                      defaultChecked={activo}
                    />
                  </div>
                </div>
              </Col>

            </Form>
            <hr />
            {id && canAddMateriaMalla && (
              <div className="table-wrapper">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.agregarOquitarMaterias({ id })}
                >
                  Agregar / Quitar Materias
                </button>
                <DataTable
                  title="Detalle de materias"
                  columns={this.columns}
                  items={materias}
                  onChangePage={this.onChangePage}
                  page={page}
                  pageSize={pageSize}
                  totalItemsCount={totalItemsCount}
                  getGridActions={key => this.getGridActions(key)}
                  onSubmit={this.onDataTableSubmit}
                  onClearFilters={this.onDataTableClearFilters}
                  initialValues={filters}
                  enableReinitialize
                />
              </div>
            )}
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxMallaForm = reduxForm({
  form: 'MallaForm',
  validate,
  enableReinitialize: true,
})(MallaForm);

export default setPropsAsInitialValues(ReduxMallaForm);
